<template>
	<div ref="dropdown" class="new-language" :class="{'new-language--open': isOpen}">
		<button class="new-language__trigger" type="button" @click="toggle" :aria-expanded="isOpen ? 'true' : 'false'">
			<img :src="currentFlag" :alt="currentLabel">
			<i class="material-icons">arrow_drop_down</i>
		</button>

		<div v-if="isOpen" class="new-language__menu">
			<button
				v-for="language in languages"
				:key="language.id"
				class="new-language__option"
				type="button"
				@click="selectLanguage(language)"
			>
				<img :src="flagFor(language)" :alt="labelFor(language)">
				<span>{{labelFor(language)}}</span>
			</button>
		</div>
	</div>
</template>

<script>
import Language, { languages } from '../../../enums/Language';
import { translate } from '../../../assets/translations';

export default {
	data() {
		return {
			isOpen: false,
			languages,
		};
	},
	computed: {
		currentLanguage() {
			return this.$store.state.language || Language.PORTUGUESE;
		},
		currentFlag() {
			return this.flagFor(this.currentLanguage);
		},
		currentLabel() {
			return this.labelFor(this.currentLanguage);
		},
		languageLabels() {
			return translate(this.currentLanguage).languageDropdown.languages;
		},
	},
	methods: {
		toggle() {
			this.isOpen = !this.isOpen;
		},
		selectLanguage(language) {
			this.$store.dispatch('language', language);
			this.isOpen = false;
		},
		flagFor(language) {
			const flags = {
				Pt: '/static/flag_br.jpg',
				En: '/static/flag_en.jpg',
				Sp: '/static/flag_sp.jpg',
			};
			return flags[language.symbol] || flags.Pt;
		},
		labelFor(language) {
			return this.languageLabels[language.symbol] || language.name;
		},
		closeOnEscape(event) {
			if (event.key === 'Escape') this.isOpen = false;
		},
		closeOnOutsideClick(event) {
			if (!this.$refs.dropdown || this.$refs.dropdown.contains(event.target)) return;
			this.isOpen = false;
		},
	},
	mounted() {
		document.addEventListener('keyup', this.closeOnEscape);
		document.addEventListener('mousedown', this.closeOnOutsideClick);
	},
	beforeDestroy() {
		document.removeEventListener('keyup', this.closeOnEscape);
		document.removeEventListener('mousedown', this.closeOnOutsideClick);
	},
};
</script>

<style scoped lang="scss">
.new-language {
	position: relative;
}

.new-language__trigger,
.new-language__option {
	display: flex;
	align-items: center;
	border: 0;
	color: #ffffff;
	cursor: pointer;
	letter-spacing: 0;
}

.new-language__trigger {
	gap: 8px;
	height: 34px;
	padding: 0 9px;
	background: rgba(5, 44, 65, .24);
	border-radius: 3px;
}

.new-language__trigger img,
.new-language__option img {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	object-fit: cover;
}

.new-language__trigger span {
	font-size: 14px;
	font-weight: 600;
}

.new-language__trigger i {
	font-size: 19px;
}

.new-language__menu {
	position: absolute;
	top: calc(100% + 8px);
	right: 0;
	width: 184px;
	padding: 13px 0;
	background: #78b2c9;
	border-radius: 6px;
	box-shadow: 0 16px 34px rgba(6, 42, 61, .24);
	z-index: 40;
}

.new-language__option {
	width: 100%;
	gap: 11px;
	padding: 9px 16px;
	background: transparent;
	font-size: 16px;
	font-weight: 600;
	text-align: left;
}

.new-language__option:hover {
	background: rgba(255, 255, 255, .12);
}

@media (min-width: 721px) {
	.new-language:not(.new-language--open) .new-language__trigger {
		background: transparent;
		padding-right: 3px;
	}

	.new-language:not(.new-language--open) .new-language__trigger span,
	.new-language:not(.new-language--open) .new-language__trigger i {
		display: none;
	}
}

@media (max-width: 420px) {
	.new-language__trigger span {
		display: none;
	}

	.new-language__menu {
		right: -52px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/header/LanguageDropdown.vue